// extracted by mini-css-extract-plugin
export default {"ViewUser":"viewUser_ViewUser__MB6dF","form":"viewUser_form__xFOm3","ViewLabel":"viewUser_ViewLabel__ki7VM","ViewLabels":"viewUser_ViewLabels__lYrZ2"};